// Hide header on scroll down, reveal on scroll up
(function () {
  const ACTIVATE_THRESHOLD = 120; // px from top before behaviour kicks in
  const UP_RESISTANCE = 500;       // px of upward scroll needed to reveal

  document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector("header");
    if (!header) return;

    let lastY = window.scrollY;
    let scrolledUp = 0;
    let ticking = false;

    function update() {
      const y = window.scrollY;
      const delta = y - lastY;

      if (y < ACTIVATE_THRESHOLD) {
        header.classList.remove("is-away");
        scrolledUp = 0;
      } else if (delta > 0) {
        // scrolling down — hide
        header.classList.add("is-away");
        scrolledUp = 0;
      } else {
        // scrolling up — accumulate until resistance is overcome
        scrolledUp -= delta; // delta is negative, so subtract makes it positive
        if (scrolledUp >= UP_RESISTANCE) {
          header.classList.remove("is-away");
        }
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  });
})();